module.exports = __webpack_public_path__ + "static/media/25-12.1a24c32c.mp3";